import { useEffect } from "react";
import { useAuth } from "../../context/AuthProvider";
import { useMenu } from "../../context/MenuProvider";
import { useGetQuery } from "../../hooks/useQuery";
import { kontrolesPeriodai } from "../../constants/KontrolesPeriodai";
import { Box } from "@mui/material";
import SingleSelect from "../shared/SingleSelect";

/**
 * Bandros strukturos filtru komponentas
 * @param {string} menesis pasirinktas menesis
 * @param {() => {}} setMenesis menesio keitimo funkcija
 * @param {number} banda pasirinkta banda
 * @param {() => {}} setBanda bandos keitimo funkcija
 * @param {number} veisle pasirinkta veisle
 * @param {() => {}} setVeisle veisles keitimo funkcija
 * @returns
 */
// [x]: jei viena banda, tai nerodyti filtro arba neleisti pasirinkti ir rodyti ta banda kaip pasirinkta
// [x]: pasirenkant kitą savininka yra issaugoma pries tai buvusio savininko banda ir tada ta isaugota banda yra siunciama kaip pasirinkta per API, todel API failina, nes banda nesavininko
const StrukturosPasirinkimai = ({
  menesis = null,
  setMenesis = null,
  banda = null,
  setBanda = null,
  veisle = null,
  setVeisle = null,
  visosBandos = true,
}) => {
  const auth = useAuth();
  const menu = useMenu();
  const arSavininkas = auth.user.role === "Ūkis";

  const banduList = useGetQuery(
    arSavininkas
      ? "bandos/visos"
      : "bandos".concat(visosBandos ? "/visos" : "") + `/${menu.savininkas}`
  );

  const arVienaBanda = banduList.length === 1;

  useEffect(() => {
    if (arVienaBanda && banduList.length > 0 && setBanda) {
      setBanda(banduList[0].banda);
    }
  }, [arVienaBanda, banduList, setBanda]);

  const bandos = banduList.map((b) => ({
    id: b.banda,
    label: arVienaBanda ? `${String(b.banda)} - Vienintelė turima banda` : String(b.banda),
  }));

  if (!arVienaBanda) {
    bandos.unshift({ id: 0, label: "Visos" });
  }

  const veisliuList = useGetQuery(
    arSavininkas ? "savininkai/veisles" : `savininkai/veisles/${menu.savininkas}`
  );

  const veisles = veisliuList.map((v) => ({
    id: v.Id,
    label: v.Pavadinimas,
  }));
  veisles.unshift({ id: 0, label: "Visos" });

  const menesiai = kontrolesPeriodai.map((k) => {
    return { id: k, label: k };
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%",
        height: "100%",
      }}
    >
      {menesis !== null && (
        <Box key="menesis">
          <SingleSelect
            pavadinimas="Metai ir mėnuo"
            pasirinkimai={menesiai}
            reiksme={menesis}
            changeReiksme={setMenesis}
          />
        </Box>
      )}
      {banda !== null && (
        <Box key="banda">
          <SingleSelect
            pavadinimas="Banda"
            pasirinkimai={bandos}
            reiksme={banda}
            changeReiksme={setBanda}
            disabled={arVienaBanda}
          />
        </Box>
      )}
      {veisle !== null && (
        <Box key="veisle">
          <SingleSelect
            pavadinimas="Veislė"
            pasirinkimai={veisles}
            reiksme={veisle}
            changeReiksme={setVeisle}
          />
        </Box>
      )}
    </Box>
  );
};

export default StrukturosPasirinkimai;
